import moment from 'moment';
import { DAYS_OF_WEEK, dateTimeFormatForRequest } from '~/constants/dateTime';
import { localeStore } from '~/mobx/localesStore';
import { TMessageCampaignSettings } from '~/view/screens/MarketingScreen/screens/MessageCampaign/CampaignEditScreen/types';
import { PostingTime } from '~/view/screens/MarketingScreen/screens/MessageCampaign/types';

export const castCampaignData = (data: any) => ({
  id: Number(data.id),
  subject: String(data.title),
  message: String(data.message),
  startAt: moment(data.start_at).toDate(),
  endAt: moment(data.end_at).toDate(),
  language: localeStore.language,
  daysOfWeek: data.settings.filter((setting: any) => setting.status).map((setting: any) => setting.weekday) as DAYS_OF_WEEK[],
  postingType: Number(data.posting_type) as PostingTime,
  createdBy: String(data.user_name),
  settings: new Map<DAYS_OF_WEEK, TMessageCampaignSettings>(
    data.settings.map((setting: any) => [setting.weekday, castCampaignTimeSettings(setting, data.start_at)])
  ),
});

export const castCampaignTimeSettings = (settings: any, date: string) => {
  return {
    id: Number(settings.id),
    message_campaign_id: Number(settings.message_campaign_id),
    weekday: Number(settings.weekday) as DAYS_OF_WEEK,
    startTime: moment.utc(`${date} ${settings.time}`, dateTimeFormatForRequest).local().toDate(),
    isValid: true,
  };
};

export const isNightTime = (date: Date | undefined) => {
  const time = moment(date).format('HH:mm:ss');
  return moment(time, 'HH:mm:ss').isSameOrBefore(moment('04:00:00', 'HH:mm:ss'));
};
